import {React, autorun, observer, observable, computed, IDisposer, when, useEffect, classNames, useAsObservableSource} from '@api'
import {CatalogItemSidebarDetailsLoader, StoresInstanceContext, useVipLocalStore, VipLocalStore} from '@modules'
import {CatalogItemPageQueryParams, globalStores, nav, StoresInstance} from '@stores'
import * as css from './DetailsRouteDashboard.css'

/// region Store

export class DetailsRouteDashboardStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)
    stores.pageStores.detailsRoute = this
  }

  @computed get storeId() {
    const {workspaceId, itemId} = this
    return `${workspaceId}-${itemId}`
  }

  registerEffects = () => {
    const {workspace, itemId, storeId, workspaceId} = this
    const _toDispose: Array<IDisposer> = [
      autorun(() => {
        const {path} = this
        if (!path) {
          nav.routeToDashboard()
        }
      }),
      autorun(() => {
        // http://localhost:3005/item-details?deployment=version-21pf-sprint-1-presales-public-demo&id=GEWeJX0BG7QYdzSXWNhF&itemId=C422398&ws=mpv
        // console.log(`Creating new sidebar details store`)
        const {path} = this
        if (path) {
          const {pathParsed} = this
          when(
            () => globalStores.flexLayout.layout?.store?.hasDoneLayoutPass,
            () => {
              const {tabCreated} = this
              if (!tabCreated) {
                const {flexLayout: {create: {createItemDetailsTab}}} = globalStores
                const tab = createItemDetailsTab({workspace: workspace?.id ?? workspaceId, path: pathParsed})
                tab.selectInTabSet()
                this.tabCreated = true
                console.log(`Created tab`, {tab})
              }
            })
          nav.routeToDashboard()
        }
      })
    ]

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  private tabCreated: boolean = false

  @computed get path() {
    /*const {itemId, workspace, workspaceId} = this
    return [{where: [{value: itemId}], esIndex: workspace?.catalog?.index ?? workspaceId}]*/
    const {queryParams} = this
    return queryParams.path
  }

  @computed get pathParsed() {
    const {path} = this
    return JSON.parse(Base64.decode(path))
  }

  @observable.ref overriddenStores: StoresInstance

  get queryParams(): CatalogItemPageQueryParams {
    return nav.queryParams as CatalogItemPageQueryParams
  }

  @computed get workspaceId() {
    const {queryParams: {ws}} = this
    return ws
  }

  @computed get workspace() {
    const {workspaces: {workspaceFor, workspaceByIndex}, workspaceId} = this
    return workspaceFor(workspaceId)
  }

  @computed get itemId() {
    const {queryParams: {itemId}} = this
    return itemId
  }
}

export const DetailsRouteDashboardStoreContext = React.createContext<DetailsRouteDashboardStore>(null)
export const useDetailsRouteDashboardStore = () => React.useContext(DetailsRouteDashboardStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const DetailsRouteDashboard = observer<MyProps>(function DetailsRouteDashboard({className, ...props}) {
  const obsProps = useAsObservableSource({...props}),
    store = useVipLocalStore((stores) => new DetailsRouteDashboardStore(stores, obsProps)),
    {itemId, workspace, overriddenStores: stores} = store

  useEffect(() => store.registerEffects(), [])

  if (!workspace?.catalog?.index) return null

  return null

  return (
    <DetailsRouteDashboardStoreContext.Provider value={store}>
      <StoresInstanceContext.Provider value={stores}>
        <div className={classNames(css.root, className)}>
          {/*<BuilderCardLoader id={itemId} esIndex={workspace.catalog.index} className={css.builderCard}/>*/}

          {stores?.sidebar?.right?.details && <CatalogItemSidebarDetailsLoader
			  esIndex={workspace.catalog.index}
			  idWithPath={itemId}
			  align='right'
			  className={css.inlineModal}
		  />}
        </div>
      </StoresInstanceContext.Provider>
    </DetailsRouteDashboardStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/catalog/DetailsRouteDashboardPage/DetailsRouteDashboard.tsx